module.exports = __webpack_public_path__ + "static/media/recipes-title-mobile.1642e593.svg";